import { useState } from 'react'

export function useLoadStates() {
  const [confirmLoad, setConfirmLoad] = useState(false)
  const [updateMaterial, setUpdateMaterial] = useState(false)
  const [checkedLoads, setCheckedLoads] = useState([])
  const [enterMaterial, setEnterMaterial] = useState(false)

  return {
    confirmLoad,
    setConfirmLoad,
    updateMaterial,
    setUpdateMaterial,
    checkedLoads,
    setCheckedLoads,
    enterMaterial,
    setEnterMaterial
  }
}
